import { render, staticRenderFns } from "./activateAndBinding.vue?vue&type=template&id=a233481e&scoped=true"
import script from "./activateAndBinding.vue?vue&type=script&lang=js"
export * from "./activateAndBinding.vue?vue&type=script&lang=js"
import style0 from "./activateAndBinding.vue?vue&type=style&index=0&id=a233481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a233481e",
  null
  
)

export default component.exports